import { computed, ref, type Ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useViewsStore } from '@/stores/views-store';

export const MAX_VIEW_NAME_LENGTH = 36;

export const useViewNameValidation = (serverDuplicateError: Ref<boolean>) => {
  const { t } = useI18n();
  const viewsStore = useViewsStore();
  const { saveViewName: name, saveViewSetAsDefault: setAsDefault } = storeToRefs(viewsStore);

  const isDuplicateName = ref(false);

  const trimmedName = computed(() => String(name.value.value ?? '').trim());

  const validateName = (value: string): boolean => {
    const trimmed = String(value ?? '').trim();
    isDuplicateName.value = trimmed.length > 0 && viewsStore.isNameTaken(trimmed);
    if (trimmed.length === 0 || trimmed.length > MAX_VIEW_NAME_LENGTH) return false;

    return !isDuplicateName.value;
  };

  const hasDuplicateError = computed(() => isDuplicateName.value || serverDuplicateError.value);

  const nameErrorText = computed(() =>
    hasDuplicateError.value ? t('dataGrid.views.modal.duplicateError') : undefined
  );

  const canSave = computed(() => name.value.isValid && !hasDuplicateError.value);

  const primaryButtonArgs = computed(() => ({
    text: t('common.save'),
    isDisabled: !canSave.value
  }));

  return {
    name,
    setAsDefault,
    trimmedName,
    validateName,
    nameErrorText,
    canSave,
    primaryButtonArgs
  };
};
